module.exports = __webpack_public_path__ + "img/stick_activites_peche.0ad5543d.svg";